import Enumerable from "linq";
import { StandardTransformer, GridTransformer, AspectRatioFixedTransformer, CenterFixedTransformer } from "./transformers";
import { ITransformable } from "./ITransformable";

export class TransformerFactory {
  constructor(private readonly _modifierKeyAssigns: { shift: string, control: string, alt: string }) {
  }

  create(event: PointerEvent, base?: ITransformable): ITransformable {
    const keys = this.toKeys(event);
    const factory = Enumerable.from(keys)
      .select(k => this.toTransformerFactory(k))
      .firstOrDefault(f => !!f);
    if (!base && factory) {
      return factory();
    }
    const transformer = base
      ? base
      : new StandardTransformer();
    return Enumerable.from(keys)
      .aggregate(transformer as ITransformable, (s, k) => this.toAdjusterFactory(k)(s));    
  }

  toKeys(event: PointerEvent): string[] {
    return Enumerable.from([
      event.shiftKey ? this._modifierKeyAssigns.shift : null,
      event.ctrlKey ? this._modifierKeyAssigns.control : null,
      event.altKey ? this._modifierKeyAssigns.alt : null,
    ])
    .where(k => !!k)
    .distinct()
    .toArray();
  }

  toTransformerFactory(key: string): () => ITransformable {
    const found = Enumerable.from(TransformerFactory._transformerFactories)
      .firstOrDefault(f => f.key === key);
    return found
      ? found.create
      : null;
  }

  private static readonly _transformerFactories: { key: string, create: () => ITransformable }[] = [
    {
      key: "grid",
      create: () => new GridTransformer(),
    },
  ];

  toAdjusterFactory(key: string): (transformer: ITransformable) => ITransformable {
    const found = Enumerable.from(TransformerFactory._adjusterFactories)
      .firstOrDefault(f => f.key === key);
    return found
      ? found.create
      : t => t;
  }

  private static readonly _adjusterFactories: { key: string, create: (transformer: ITransformable) => ITransformable }[] = [
    {
      key: "aspectRatioFixed",
      create: t => new AspectRatioFixedTransformer(t),
    },
    {
      key: "centerFixed",
      create: t => new CenterFixedTransformer(t),
    },
  ];
}
